import React from 'react'

import { Table } from 'antd'

import { adminHttpClient } from 'core/application/commons/adminHttpClient'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'
import { PagedMigrationLog } from 'core/application/csiDashboard/migration/getMigrationLogs'

import { formatDateTime } from 'common/dateFormatters'

interface MigrationLogsTableProps {
  onTableChange: (value: any) => void
  loadingMigrationLogsResults: boolean
  migrationLogsResults: PagedMigrationLog
}

const MigrationLogsTable: React.FC<MigrationLogsTableProps> = ({
  onTableChange,
  loadingMigrationLogsResults,
  migrationLogsResults,
}) => {
  const columns = [
    {
      title: 'Date',
      dataIndex: 'logDate',
      key: 'logDate',
      sorter: false,
      render: (text: string, record: any) => <span>{record.logDate && formatDateTime(record.logDate)}</span>,
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
      sorter: false,
      render: (text: string, record: any) => <span className={'event-' + record.eventType}>{record.message}</span>,
    },
  ]

  const onMigrationLogsTableChange = (pagination: any, filters: any, sorter: any) => {
    const obj = {
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
      orderColumn: sorter.field,
      orderDescending: sorter.order === 'descend',
    }
    onTableChange(obj)
  }

  return (
    <Table
      dataSource={migrationLogsResults.items}
      loading={loadingMigrationLogsResults}
      onChange={onMigrationLogsTableChange}
      columns={columns}
      pagination={{
        total: migrationLogsResults.totalItemCount,
        pageSize: migrationLogsResults.pageSize,
        current: migrationLogsResults.pageNumber,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200'],
      }}
    ></Table>
  )
}

export default MigrationLogsTable
